import { render } from "./BuypassSettings.vue?vue&type=template&id=ec30f250"
import script from "./BuypassSettings.vue?vue&type=script&lang=js"
export * from "./BuypassSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__